import wapplrClient from 'wapplr'
import wapplrPwa from 'wapplr-pwa'
import wapplrReact from 'wapplr-react'

import setContents from '../common/setContents'
import { getConfig as getCommonConfig } from '../common/config'

export function getConfig(p = {}) {
    const { config = {} } = p
    const clientConfig = config.client || {}
    const commonConfig = getCommonConfig(p).config
    const common = { ...commonConfig.common }
    return {
        config: {
            ...config,
            common,
            client: { ...clientConfig }
        }
    }
}

export default async function createClient(p = {}) {
    const { config } = getConfig(p)
    const wapp = p.wapp || wapplrClient({ ...p, config })

    await wapplrPwa({ wapp })
    wapplrReact({ wapp })

    setContents({ wapp })

    return wapp
}

const defaultConfig = {
    config: {
        globals: {
            DEV: (typeof DEV !== 'undefined') ? DEV : undefined,
            WAPP: (typeof WAPP !== 'undefined') ? WAPP : undefined,
            RUN: (typeof RUN !== 'undefined') ? RUN : undefined,
            TYPE: (typeof TYPE !== 'undefined') ? TYPE : undefined,
            ROOT: (typeof ROOT !== 'undefined') ? ROOT : '/',
            NAME: (typeof NAME !== 'undefined') ? NAME : undefined
        }
    }
}

export async function run(p = defaultConfig) {
    if (p?.config?.globals && !p.config.globals.RUN) {
        p.config.globals.RUN = p.config?.globals.NAME || 'vlm-agent'
    }

    const { config } = getConfig(p)
    const wapp = await createClient({ ...p, config })
    const { DEV } = wapp.globals

    const app = wapp.client.app
    wapp.client.listen()

    if (typeof DEV !== 'undefined' && DEV && module.hot) {
        app.hot = module.hot
        module.hot.accept()
    }

    return wapp
}

if (typeof RUN !== 'undefined' && RUN === 'vlm-agent') {
    run()
}
